<template>
  <a-card :bordered="false">
    <div>
      <channel-search @wechatAppId="test" :wechat-type="'1,2'"></channel-search>

      <div class="mod-config">
        <a-form-model
          layout="inline"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
        >
          <a-form-model-item>
            <a-input
              v-model="dataForm.matchValue"
              placeholder="匹配关键词"
              clearable
            ></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-button @click="getDataList()">查询</a-button>
            <a-button type="primary" @click="addOrUpdateHandle()"
              >新增</a-button
            >
            <a-button
              type="danger"
              @click="onDelete()"
              :disabled="dataListSelections.length <= 0"
              >批量删除</a-button
            >
          </a-form-model-item>
        </a-form-model>
        <a-table
          :columns="columns"
          :data-source="dataList"
          :row-selection="{
            selectedRowKeys: dataListSelections,
            onChange: onSelectChange
          }"
          bordered
          rowKey="id"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="addOrUpdateHandle(record.id)">修改</a>
            <a-divider type="vertical" />
            <a-popconfirm
              v-if="dataList.length"
              title="Sure to delete?"
              @confirm="() => onDelete(record.id)"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </span>
        </a-table>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update
          v-if="addOrUpdateVisible"
          ref="addOrUpdate"
          @refreshDataList="getDataList"
          :wechatAppId="this.wechatAppId"
        ></add-or-update>
      </div>
    </div>
  </a-card>
</template>

<script>
import { mapState } from 'vuex';
import channelSearch from '../../../components/wechat/channelSearch';
import { getAction, postAction } from '@/api/manage';
import AddOrUpdate from './msg-reply-rule-add-or-update';
export default {
  components: {
    channelSearch,
    AddOrUpdate
  },
  data() {
    return {
      dataForm: {
        matchValue: ''
      },
      wechatAppId: '',
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: false,
        pageSizeOptions: ['10', '20', '50', '100'], //每页中显示的数据
        showTotal: total => `共有 ${total} 条数据` //分页中显示总的数据
      },
      columns: [
        {
          title: '规则名称',
          dataIndex: 'ruleName',
          key: 'ruleName'
        },
        {
          title: '匹配关键词',
          dataIndex: 'matchValue',
          key: 'matchValue'
        },
        {
          title: '消息类型',
          dataIndex: 'replyType',
          key: 'replyType'
        },
        {
          title: '回复内容',
          dataIndex: 'replyContent',
          key: 'replyContent'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    };
  },
  computed: mapState({
    KefuMsgType: state => state.message.KefuMsgType
  }),

  mounted() {
    this.getDataList();
  },
  methods: {
    test(data) {
      this.wechatAppId = data;
      this.getDataList();
    },
    onSelectChange(selectedRowKeys) {
      this.dataListSelections = selectedRowKeys;
      console.log(this.dataListSelections);
    },
    handleTableChange(pagination) {
      const page = { ...this.pagination };
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.pageIndex = pagination.current;
      this.pageSize = pagination.pageSize;
      this.pagination = page;
      this.getDataList();
    },
    // 获取数据列表
    getDataList() {
      this.dataListLoading = true;
      getAction(process.env.VUE_APP_CMS_WECHAT + '/manage/msgReplyRule/list', {
        appId: this.wechatAppId,
        page: this.pageIndex,
        limit: this.pageSize,
        matchValue: this.dataForm.matchValue
      }).then(res => {
        if (res.success && res.code === 200) {
          this.dataList = res.result.list;
          this.pagination.total = res.result.totalCount;
        } else {
          this.dataList = [];
          this.totalCount = 0;
        }
        this.dataListLoading = false;
      });
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    // 新增 / 修改
    addOrUpdateHandle(id) {
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id);
      });
    },
    // 删除
    onDelete(id) {
      const dataSource = [...this.dataList];
      var ids = id ? [id] : this.dataListSelections.map(item => item);
      this.$http({
        url: process.env.VUE_APP_CMS_WECHAT + '/manage/msgReplyRule/delete',
        method: 'post',
        data: ids
      }).then(res => {
        if (res.success && res.code === 200) {
          this.$message.success('操作成功');
          this.dataList = dataSource.filter(item => item.id !== id);
          this.getDataList();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    replyTypeFormat(row, column, cellValue) {
      return this.KefuMsgType[cellValue];
    }
  }
};
</script>
<style scoped>
.ant-btn-danger {
  color: #fff;
  background-color: #ff4d4f;
  border-color: #ff4d4f;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
</style>
